import PropTypes from 'prop-types';
import React from 'react';
import createCustomEvent from 'utils/createCustomEvent';

/**
 * @typedef {Object} DecorativeImageProps
 * @property {string} src - The source URL of the decorative image
 * @property {string} [alt] - The alt text for the image (optional, defaults to empty string)
 * @property {string} [className] - Additional class names to apply
 */

/**
 * Renders an image that is purely decorative.
 * We'll hide it from screen readers so that it doesn't interfere with accessibility.
 * Also includes dispatching a resize event when the image loads to handle layout changes.
 */
const DecorativeImage = ({ src, alt, className }) => {
  /**
   * Handle resizing after image loads in case the image size affects layout.
   */
  const handleImageLoad = () => {
    window.dispatchEvent(createCustomEvent('resize', true));
  };

  return <img className={className} src={src} alt={alt || ''} onLoad={handleImageLoad} aria-hidden="true" />;
};

DecorativeImage.propTypes /* remove-proptypes */ = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default DecorativeImage;
